import React from 'react'
import { Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import './index.css'
import ButtonPurple from 'components/design/Form/ButtonPurple'

const ModalSlackConnect = () => {
  const settings = useSelector(state => state.settings)
  const dispatch = useDispatch()
  const handleCancel = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  const handleConnectSlack = () => {
    dispatch({
      type: 'apps/CALL_SLACK_SUPPORT_MANUAL_INTENT',
    })
    handleCancel()
  }

  const { visibleModalID } = settings
  const modalID = 'slackConnect'
  const visible = modalID === visibleModalID
  return (
    <Modal
      className="slack_connect_modal"
      onCancel={handleCancel}
      afterClose={handleCancel}
      open={visible}
      footer={null}
      maskClosable={false}
    >
      <>
        <div className="slack-modal-content">
          <div className="slack-icon-wrapper">
            <div className="slack-icon" />
          </div>
          <div className="slack-modal-title">Slack Support</div>
          <div className="slack-modal-subtitle">
            Chat directly with our engineers in a private Slack channel. Free during integration,
            premium support options available for existing customers.
          </div>
        </div>
        <ButtonPurple
          holderStyles={{ width: '100%' }}
          buttonStyles={{ width: '100%' }}
          onClick={handleConnectSlack}
          buttonText="Request Slack Support"
        />
      </>
    </Modal>
  )
}

export default ModalSlackConnect
